export const base64ToFile = async (base64: string, filename: string, mimeType: string): Promise<File> => {
  const response = await fetch(base64)
  const buffer = await response.arrayBuffer()

  return new File([buffer], filename, { type: mimeType });
}